// Reads JSON data stored in the markup using add_js_variable() and stores it in zr.page.model
window.zr = window.zr || {};
window.zr.page = window.zr.page || {};
window.zr.page.model = JSON.parse(document.getElementById('js_variables').innerHTML);
